import { Button, DatePicker, Form, Row, Space } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSubsidiaries } from '../../../../appRedux/actions';
import {
  buttonLabel,
  formConfig,
  placeHolders,
  profitabilityOptions,
} from '../../../../constants';
import { CustomSelect } from '../../../uiComponents';

export const ProfitabilityByBranchFilter = ({ onSubmit }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { subsidiaries } = useSelector((state) => state.subsidiary);

  useEffect(() => {
    dispatch(getSubsidiaries({ status: 1 }));
  }, [dispatch]);

  return (
    <Row>
      <Form {...formConfig} onFinish={onSubmit} form={form}>
        <Space>
          <Form.Item name="branchId">
            <CustomSelect
              placeholder={placeHolders.branch}
              style={{ minWidth: '200px' }}
              options={subsidiaries?.map(({ id, name }) => ({
                value: id,
                label: name,
              }))}
            ></CustomSelect>
          </Form.Item>
          <Form.Item name="year">
            <DatePicker picker="year" format={'YYYY'} />
          </Form.Item>
          <Form.Item name="type">
            <CustomSelect
              placeholder={placeHolders.profitability}
              style={{ minWidth: '200px' }}
              options={profitabilityOptions}
            ></CustomSelect>
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="btn-form" htmlType="submit">
              {buttonLabel.search}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Row>
  );
};
